type AddressFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
};

type AddressFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  orElse: () => R;
};

abstract class _AddressFailure extends Error {
  public abstract map<R>(callbacks: AddressFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: AddressFailureMaybeMap<R>): R;
}

class ServerFailure extends _AddressFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: AddressFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: AddressFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _AddressFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: AddressFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: AddressFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

export type AddressFailure = ServerFailure | NetworkFailure;

export const AddressFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
};
